import { createFileRoute } from '@tanstack/react-router'
import { SettingsPage } from '_/features/settings/ui/pages/settings-page'

export const Route = createFileRoute('/_authenticated/settings/general')({
	staticData: { title: 'settings_title' },
	component: SettingsPage,
})
